import styled from 'styled-components'

export const SectionSkills = styled.div`
  text-align: center;
  margin: 32px 0;
`
export const ListSkills = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  img {
    margin: 16px;
  }
`
